const OFFER_ADS_DATA = {
  titleA: 'Come join us for a lunch',
  titleA2: 'this weekend and enjoy',
  titleB: 'FLAT 10% OFF',
  btnLabel: 'Book Table',
  btnHref: '#',
  adsImg: '/assets/offer-ads.png'
};

export default OFFER_ADS_DATA;